module.exports = __webpack_public_path__ + "static/media/Exclamation-Orange.5b9c50a8.svg";